/* eslint max-classes-per-file: 0 */

import {
  VPRPublication as Data,
  VPRPublicationCollection as Collection,
} from '@/typings/api/VPRPublications'
import { VPRPublicationsApi as Api } from '@/api/resources/Collector'

import { Fabric } from '@/store/createCrudModule'

const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class VPRPublicationsTransformerParams extends TransformerParams {
}

export class VPRPublicationsAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new VPRPublicationsTransformerParams();
}
